export default __webpack_public_path__ + "static/media/logo-suche.53585747.svg";